import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Routes from '../../../routes';
import { TableRowInput } from './tr-input';
import { TableRowSelect } from './tr-select';
import { TableRowToogle } from './toogle';
import { FooterTableButton } from './footer-table-button';

export default class TableSucursal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
        };
    }

    render() {

        const { baseUrl } = this.state;
        const { clasificacionOptions,sucursales, sucursal, sucursalF, onChange, onChangeInputTableSucursal, onSaveFiscalSucursal, globalDescription, globalOptions,  globalSelect } = this.props;
        const options = sucursales.map((item, index) => <option key={index} value={item.Suc_Id}>{item.Nombre}</option>);
        const optionsGlobal = globalOptions.map((item, index) => <option key={index} value={item.Id}>{item.Nombre}</option>);
        const optionsClasificacion = clasificacionOptions.map((item, index) => <option key={index} value={item.Id}>{item.Nombre}</option>);
        const optionsfactura = <option value="0">Tipo</option>
        
        return(
            <div className="table-responsive">
                <table className="table table-sm">
                    <tbody>
                        <TableRowSelect   title="Sucursal"
                                            name="sucursal"
                                            options={options}
                                            value={sucursalF.Suc_id}
                                            onChange={onChange}
                         />
                        <TableRowInput   title="Serie"
                                            type="text"
                                            name="Fiscal_Serie"
                                            value={sucursalF.Fiscal_Serie}
                                            onChange={onChangeInputTableSucursal}
                         />
                        <TableRowInput title="Consecutivo"
                                            type="text"
                                            name="Fiscal_Consecutivo"
                                            value={sucursalF.Fiscal_Consecutivo}
                                            onChange={onChangeInputTableSucursal}
                        />
                        <TableRowSelect title="Tipo Factura Global"
                                            name="tipofacturaglobal"
                                            options={optionsGlobal}
                                            value={sucursalF.Fiscal_Tipo_Global_id}
                                            onChange={onChange}
                        />
                        <TableRowSelect title="Clasificación"
                            name="GlobalClasificacion"
                            options={optionsClasificacion}
                            value={sucursalF.Fiscal_Global_Clasificacion}
                            onChange={onChange}
                        />
                        <tr>
                            <td colSpan="2">
                                <input type="text" className="input-no-border form-control" name="descriptcionFactura" value={globalDescription} onChange={onchange} />
                            </td>
                            
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <button type="button" className="btn btn-custom-theme float-right"><i className="far fa-save" onClick={onSaveFiscalSucursal}></i></button>
                                <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right">
                                    <i className="fas fa-angle-double-left"></i>
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./Public/src/js/component/parametro/children/tabla-sucursal.jsx